import { render, staticRenderFns } from "./CoozzyPinterestIcon.vue?vue&type=template&id=3b83e6f3&scoped=true"
import script from "./CoozzyPinterestIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyPinterestIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyPinterestIcon.vue?vue&type=style&index=0&id=3b83e6f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b83e6f3",
  null
  
)

export default component.exports